import React, { useState, useEffect, useCallback } from 'react';
import { apiFetch } from '../bizsuite-app';

const ACCOUNT_TYPES = ['Asset', 'Liability', 'Equity', 'Revenue', 'Expense'];
const EMPTY_ACCOUNT = { account_code: '', account_name: '', type: '', group_name: '', sub_group: '' };
const EMPTY_LINE = { account_id: '', debit: '', credit: '', narration: '' };

/* ── Tally LLP Chart of Accounts Template ── */
const TALLY_LLP_COA = [
  { account_code: '3001', account_name: 'Partner Capital \u2013 Partner A', type: 'Equity', group_name: 'Capital Account', sub_group: 'Partners Capital' },
  { account_code: '3002', account_name: 'Partner Capital \u2013 Partner B', type: 'Equity', group_name: 'Capital Account', sub_group: 'Partners Capital' },
  { account_code: '3003', account_name: 'Partner Current Account \u2013 Partner A', type: 'Equity', group_name: 'Capital Account', sub_group: 'Partners Current' },
  { account_code: '3004', account_name: 'Partner Current Account \u2013 Partner B', type: 'Equity', group_name: 'Capital Account', sub_group: 'Partners Current' },
  { account_code: '3005', account_name: 'Retained Earnings', type: 'Equity', group_name: 'Capital Account', sub_group: 'Reserves' },
  { account_code: '2001', account_name: 'Term Loan \u2013 Bank', type: 'Liability', group_name: 'Loans (Liability)', sub_group: 'Secured Loans' },
  { account_code: '2002', account_name: 'Unsecured Loan \u2013 Partners', type: 'Liability', group_name: 'Loans (Liability)', sub_group: 'Unsecured Loans' },
  { account_code: '2003', account_name: 'Security Deposit Received', type: 'Liability', group_name: 'Loans (Liability)', sub_group: 'Deposits' },
  { account_code: '2101', account_name: 'Vendors \u2013 Professional Services', type: 'Liability', group_name: 'Sundry Creditors', sub_group: 'Trade Payables' },
  { account_code: '2102', account_name: 'Vendors \u2013 Cloud & Software', type: 'Liability', group_name: 'Sundry Creditors', sub_group: 'Trade Payables' },
  { account_code: '2103', account_name: 'Vendors \u2013 Office Expenses', type: 'Liability', group_name: 'Sundry Creditors', sub_group: 'Trade Payables' },
  { account_code: '2104', account_name: 'Advance from Customers', type: 'Liability', group_name: 'Sundry Creditors', sub_group: 'Advances' },
  { account_code: '2201', account_name: 'Output CGST', type: 'Liability', group_name: 'Duties & Taxes', sub_group: 'GST Payable' },
  { account_code: '2202', account_name: 'Output SGST', type: 'Liability', group_name: 'Duties & Taxes', sub_group: 'GST Payable' },
  { account_code: '2203', account_name: 'Output IGST', type: 'Liability', group_name: 'Duties & Taxes', sub_group: 'GST Payable' },
  { account_code: '2204', account_name: 'Input CGST', type: 'Liability', group_name: 'Duties & Taxes', sub_group: 'GST Receivable' },
  { account_code: '2205', account_name: 'Input SGST', type: 'Liability', group_name: 'Duties & Taxes', sub_group: 'GST Receivable' },
  { account_code: '2206', account_name: 'Input IGST', type: 'Liability', group_name: 'Duties & Taxes', sub_group: 'GST Receivable' },
  { account_code: '2207', account_name: 'TDS Payable \u2013 Professional', type: 'Liability', group_name: 'Duties & Taxes', sub_group: 'TDS Payable' },
  { account_code: '2208', account_name: 'TDS Payable \u2013 Contract', type: 'Liability', group_name: 'Duties & Taxes', sub_group: 'TDS Payable' },
  { account_code: '2209', account_name: 'Export Sales \u2013 LUT / Without GST', type: 'Liability', group_name: 'Duties & Taxes', sub_group: 'Export Duties' },
  { account_code: '1001', account_name: 'Axis Bank \u2013 Current Account', type: 'Asset', group_name: 'Bank Accounts', sub_group: 'Bank' },
  { account_code: '1002', account_name: 'Axis Bank \u2013 Project Account', type: 'Asset', group_name: 'Bank Accounts', sub_group: 'Bank' },
  { account_code: '1003', account_name: 'EEFC Account \u2013 USD', type: 'Asset', group_name: 'Bank Accounts', sub_group: 'EEFC' },
  { account_code: '1010', account_name: 'Cash', type: 'Asset', group_name: 'Cash-in-Hand', sub_group: 'Cash' },
  { account_code: '1101', account_name: 'Customers \u2013 Domestic', type: 'Asset', group_name: 'Sundry Debtors', sub_group: 'Trade Receivables' },
  { account_code: '1102', account_name: 'Customers \u2013 Export', type: 'Asset', group_name: 'Sundry Debtors', sub_group: 'Trade Receivables' },
  { account_code: '1103', account_name: 'Export Receivables \u2013 USD / FCY', type: 'Asset', group_name: 'Sundry Debtors', sub_group: 'Forex Receivables' },
  { account_code: '1201', account_name: 'TDS Receivable', type: 'Asset', group_name: 'Current Assets', sub_group: 'Receivables' },
  { account_code: '1202', account_name: 'Unbilled Revenue (WIP)', type: 'Asset', group_name: 'Current Assets', sub_group: 'Receivables' },
  { account_code: '1203', account_name: 'Prepaid Expenses', type: 'Asset', group_name: 'Current Assets', sub_group: 'Prepaid' },
  { account_code: '1204', account_name: 'Employee Advances', type: 'Asset', group_name: 'Current Assets', sub_group: 'Advances' },
  { account_code: '1501', account_name: 'Computers & Laptops', type: 'Asset', group_name: 'Fixed Assets', sub_group: 'IT Equipment' },
  { account_code: '1502', account_name: 'Servers & Network Equipment', type: 'Asset', group_name: 'Fixed Assets', sub_group: 'IT Equipment' },
  { account_code: '1503', account_name: 'Office Furniture & Fixtures', type: 'Asset', group_name: 'Fixed Assets', sub_group: 'Furniture' },
  { account_code: '1504', account_name: 'Leasehold Improvements', type: 'Asset', group_name: 'Fixed Assets', sub_group: 'Leasehold' },
  { account_code: '1505', account_name: 'Accumulated Depreciation', type: 'Asset', group_name: 'Fixed Assets', sub_group: 'Contra' },
  { account_code: '4001', account_name: 'IT Consulting Services', type: 'Revenue', group_name: 'Direct Income', sub_group: 'Consulting' },
  { account_code: '4002', account_name: 'SAP Implementation Services', type: 'Revenue', group_name: 'Direct Income', sub_group: 'Implementation' },
  { account_code: '4003', account_name: 'Application Support Services', type: 'Revenue', group_name: 'Direct Income', sub_group: 'Support' },
  { account_code: '4004', account_name: 'Time & Material Billing', type: 'Revenue', group_name: 'Direct Income', sub_group: 'T&M' },
  { account_code: '4005', account_name: 'Fixed Price Project Revenue', type: 'Revenue', group_name: 'Direct Income', sub_group: 'Fixed Price' },
  { account_code: '4006', account_name: 'Export Software Services', type: 'Revenue', group_name: 'Direct Income', sub_group: 'Export' },
  { account_code: '4007', account_name: 'SaaS / Subscription Revenue', type: 'Revenue', group_name: 'Direct Income', sub_group: 'SaaS' },
  { account_code: '4101', account_name: 'Interest Income', type: 'Revenue', group_name: 'Indirect Income', sub_group: 'Financial' },
  { account_code: '4102', account_name: 'Foreign Exchange Gain', type: 'Revenue', group_name: 'Indirect Income', sub_group: 'Forex' },
  { account_code: '4103', account_name: 'Foreign Exchange Gain \u2013 Realised', type: 'Revenue', group_name: 'Indirect Income', sub_group: 'Forex' },
  { account_code: '5001', account_name: 'Salaries \u2013 Billable Staff', type: 'Expense', group_name: 'Direct Expenses', sub_group: 'Payroll' },
  { account_code: '5002', account_name: 'Subcontracting Charges', type: 'Expense', group_name: 'Direct Expenses', sub_group: 'Subcontracting' },
  { account_code: '5003', account_name: 'Freelance Consultant Fees', type: 'Expense', group_name: 'Direct Expenses', sub_group: 'Consulting' },
  { account_code: '5004', account_name: 'Cloud Hosting Charges', type: 'Expense', group_name: 'Direct Expenses', sub_group: 'Infrastructure' },
  { account_code: '5005', account_name: 'Project Software Licenses', type: 'Expense', group_name: 'Direct Expenses', sub_group: 'Licenses' },
  { account_code: '5006', account_name: 'Travel \u2013 Client Projects', type: 'Expense', group_name: 'Direct Expenses', sub_group: 'Travel' },
  { account_code: '5101', account_name: 'Salaries \u2013 Non\u2011Billable Staff', type: 'Expense', group_name: 'Indirect Expenses', sub_group: 'Payroll' },
  { account_code: '5102', account_name: 'Recruitment Expenses', type: 'Expense', group_name: 'Indirect Expenses', sub_group: 'HR' },
  { account_code: '5103', account_name: 'Training & Certification', type: 'Expense', group_name: 'Indirect Expenses', sub_group: 'HR' },
  { account_code: '5104', account_name: 'Staff Welfare Expenses', type: 'Expense', group_name: 'Indirect Expenses', sub_group: 'HR' },
  { account_code: '5105', account_name: 'Office Rent', type: 'Expense', group_name: 'Indirect Expenses', sub_group: 'Premises' },
  { account_code: '5106', account_name: 'Internet & Communication', type: 'Expense', group_name: 'Indirect Expenses', sub_group: 'Communication' },
  { account_code: '5107', account_name: 'Software Subscriptions', type: 'Expense', group_name: 'Indirect Expenses', sub_group: 'IT' },
  { account_code: '5108', account_name: 'Legal & Professional Fees', type: 'Expense', group_name: 'Indirect Expenses', sub_group: 'Professional' },
  { account_code: '5109', account_name: 'Marketing Expenses', type: 'Expense', group_name: 'Indirect Expenses', sub_group: 'Marketing' },
  { account_code: '5110', account_name: 'Bank Charges', type: 'Expense', group_name: 'Indirect Expenses', sub_group: 'Financial' },
  { account_code: '5111', account_name: 'Interest on Loans', type: 'Expense', group_name: 'Indirect Expenses', sub_group: 'Financial' },
  { account_code: '5112', account_name: 'Depreciation', type: 'Expense', group_name: 'Indirect Expenses', sub_group: 'Depreciation' },
  { account_code: '5113', account_name: 'Foreign Exchange Loss \u2013 Realised', type: 'Expense', group_name: 'Indirect Expenses', sub_group: 'Forex' },
  { account_code: '5114', account_name: 'Bank Forex Charges', type: 'Expense', group_name: 'Indirect Expenses', sub_group: 'Forex' },
];

export default function Finance() {
  const [tab, setTab] = useState('coa');

  return (
    <div>
      <div className="tabs" style={{ marginBottom: 16 }}>
        {[
          { key: 'coa', label: 'Chart of Accounts' },
          { key: 'journal', label: 'Journal Entries' },
          { key: 'trial', label: 'Trial Balance' },
          { key: 'pl', label: 'Profit & Loss' },
          { key: 'bs', label: 'Balance Sheet' },
        ].map(t => (
          <button key={t.key} className={`tab-btn ${tab === t.key ? 'active' : ''}`} onClick={() => setTab(t.key)}>{t.label}</button>
        ))}
      </div>
      {tab === 'coa' && <ChartOfAccounts />}
      {tab === 'journal' && <JournalEntries />}
      {tab === 'trial' && <TrialBalance />}
      {tab === 'pl' && <ProfitLoss />}
      {tab === 'bs' && <BalanceSheet />}
    </div>
  );
}

/* =================================================================
   Chart of Accounts Tab
   ================================================================= */
function ChartOfAccounts() {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [form, setForm] = useState({ ...EMPTY_ACCOUNT });
  const [editing, setEditing] = useState(null);
  const [filterType, setFilterType] = useState('');
  const [filterGroup, setFilterGroup] = useState('');
  const [importing, setImporting] = useState(false);
  const [importMsg, setImportMsg] = useState('');
  const [collapsedGroups, setCollapsedGroups] = useState({});

  const fetchAccounts = useCallback(async () => {
    try {
      const res = await apiFetch('/api/finance/chart-of-accounts');
      if (res.ok) {
        const data = await res.json();
        setAccounts(data.accounts || []);
      }
    } catch (e) { /* handled */ }
    setLoading(false);
  }, []);

  useEffect(() => { fetchAccounts(); }, [fetchAccounts]);

  async function handleSave() {
    try {
      const method = editing ? 'PUT' : 'POST';
      const url = editing ? `/api/finance/chart-of-accounts/${editing.id}` : '/api/finance/chart-of-accounts';
      const res = await apiFetch(url, { method, body: JSON.stringify(form) });
      if (res.ok) {
        setModalOpen(false);
        setEditing(null);
        setForm({ ...EMPTY_ACCOUNT });
        fetchAccounts();
      }
    } catch (e) { /* handled */ }
  }

  async function handleDeactivate(id) {
    if (!confirm('Deactivate this account?')) return;
    await apiFetch(`/api/finance/chart-of-accounts/${id}/deactivate`, { method: 'POST' });
    fetchAccounts();
  }

  async function handleDelete(id) {
    if (!confirm('Delete this account permanently?')) return;
    await apiFetch(`/api/finance/chart-of-accounts/${id}`, { method: 'DELETE' });
    fetchAccounts();
  }

  function openEdit(acc) {
    setEditing(acc);
    setForm({ account_code: acc.account_code, account_name: acc.account_name, type: acc.type, group_name: acc.group_name || '', sub_group: acc.sub_group || '' });
    setModalOpen(true);
  }

  async function importTallyLLP() {
    if (!confirm('Import Tally LLP Chart of Accounts (67 accounts)? Duplicates will be skipped.')) return;
    setImporting(true);
    setImportMsg('');
    try {
      const res = await apiFetch('/api/finance/chart-of-accounts/import', {
        method: 'POST',
        body: JSON.stringify({ accounts: TALLY_LLP_COA })
      });
      if (res.ok) {
        const data = await res.json();
        setImportMsg(`${data.imported} imported, ${data.skipped} skipped`);
        fetchAccounts();
      } else {
        setImportMsg('Import failed');
      }
    } catch (e) {
      setImportMsg('Import error');
    }
    setImporting(false);
    setTimeout(() => setImportMsg(''), 4000);
  }

  function toggleGroup(key) {
    setCollapsedGroups(prev => ({ ...prev, [key]: !prev[key] }));
  }

  let filtered = accounts;
  if (filterType) filtered = filtered.filter(a => a.type === filterType);
  if (filterGroup) filtered = filtered.filter(a => a.group_name === filterGroup);

  // Group by group_name (Tally groups), then sort within each
  const grouped = {};
  filtered.forEach(a => {
    const key = a.group_name || a.type || 'Other';
    if (!grouped[key]) grouped[key] = [];
    grouped[key].push(a);
  });

  // Define a display order for groups
  const GROUP_ORDER = [
    'Capital Account', 'Loans (Liability)', 'Sundry Creditors', 'Duties & Taxes',
    'Bank Accounts', 'Cash-in-Hand', 'Sundry Debtors', 'Current Assets', 'Fixed Assets',
    'Direct Income', 'Indirect Income', 'Direct Expenses', 'Indirect Expenses',
    'Assets', 'Liabilities', 'Equity', 'Revenue', 'Expenses'
  ];
  const groupKeys = Object.keys(grouped).sort((a, b) => {
    const ia = GROUP_ORDER.indexOf(a), ib = GROUP_ORDER.indexOf(b);
    if (ia >= 0 && ib >= 0) return ia - ib;
    if (ia >= 0) return -1;
    if (ib >= 0) return 1;
    return a.localeCompare(b);
  });

  const TYPE_COLORS = { Asset: '#10b981', Liability: '#ef4444', Equity: '#8b5cf6', Revenue: '#3b82f6', Expense: '#f59e0b' };
  const allGroups = [...new Set(accounts.map(a => a.group_name).filter(Boolean))].sort();

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <select className="form-control" value={filterType} onChange={e => setFilterType(e.target.value)} style={{ width: 160 }}>
            <option value="">All Types</option>
            {ACCOUNT_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
          </select>
          <select className="form-control" value={filterGroup} onChange={e => setFilterGroup(e.target.value)} style={{ width: 200 }}>
            <option value="">All Groups</option>
            {allGroups.map(g => <option key={g} value={g}>{g}</option>)}
          </select>
          <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)' }}>{filtered.length} accounts</span>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          {importMsg && <span style={{ fontSize: 12, color: '#10b981', fontWeight: 500 }}>{importMsg}</span>}
          <button className="btn btn-secondary" onClick={importTallyLLP} disabled={importing}>
            {importing ? 'Importing...' : 'Import Tally LLP CoA'}
          </button>
          <button className="btn btn-primary" onClick={() => { setEditing(null); setForm({ ...EMPTY_ACCOUNT }); setModalOpen(true); }}>+ New Account</button>
        </div>
      </div>

      {loading ? <p style={{ textAlign: 'center' }}>Loading...</p> : filtered.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 40, color: 'rgba(255,255,255,0.4)' }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>{'\u{1F4CA}'}</div>
          <p>No accounts found. Import the Tally LLP template or add accounts manually.</p>
        </div>
      ) : (
        groupKeys.map(groupName => {
          const accs = grouped[groupName];
          const groupType = accs[0]?.type || '';
          const collapsed = collapsedGroups[groupName];
          return (
            <div key={groupName} className="card" style={{ marginBottom: 8 }}>
              <div
                className="card-header"
                style={{ cursor: 'pointer', userSelect: 'none', display: 'flex', alignItems: 'center', gap: 8 }}
                onClick={() => toggleGroup(groupName)}
              >
                <span style={{ fontSize: 10, transition: 'transform 0.2s', transform: collapsed ? 'rotate(-90deg)' : 'rotate(0)' }}>{'\u25BC'}</span>
                <h4 style={{ flex: 1, margin: 0 }}>{groupName}</h4>
                <span className="badge" style={{ background: TYPE_COLORS[groupType] || '#64748b', color: '#fff', fontSize: 10 }}>{groupType}</span>
                <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)' }}>{accs.length} {accs.length === 1 ? 'account' : 'accounts'}</span>
              </div>
              {!collapsed && (
                <table className="data-table">
                  <thead><tr><th style={{ width: 80 }}>Code</th><th>Ledger Name</th><th>Sub-Group</th><th style={{ width: 70 }}>Status</th><th style={{ width: 140 }}>Actions</th></tr></thead>
                  <tbody>
                    {accs.map(a => (
                      <tr key={a.id} style={{ opacity: a.is_active === false ? 0.5 : 1 }}>
                        <td style={{ fontFamily: 'monospace', fontWeight: 600, color: TYPE_COLORS[a.type] || '#e2e8f0' }}>{a.account_code}</td>
                        <td>{a.account_name}</td>
                        <td style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13 }}>{a.sub_group || '\u2014'}</td>
                        <td><span className={`badge ${a.is_active !== false ? 'badge-green' : 'badge-gray'}`} style={{ fontSize: 10 }}>{a.is_active !== false ? 'Active' : 'Inactive'}</span></td>
                        <td>
                          <button className="btn btn-sm btn-secondary" onClick={() => openEdit(a)} style={{ marginRight: 4 }}>Edit</button>
                          {a.is_active !== false && <button className="btn btn-sm" style={{ background: 'rgba(239,68,68,0.15)', color: '#ef4444', border: '1px solid rgba(239,68,68,0.3)' }} onClick={() => handleDeactivate(a.id)}>Off</button>}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          );
        })
      )}

      {modalOpen && (
        <div className="modal-overlay" onClick={() => setModalOpen(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: 500 }}>
            <div className="modal-header"><h3>{editing ? 'Edit Account' : 'New Account'}</h3><button className="modal-close" onClick={() => setModalOpen(false)}>X</button></div>
            <div className="modal-body">
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div className="form-group"><label>Code *</label><input className="form-control" value={form.account_code} onChange={e => setForm({ ...form, account_code: e.target.value })} /></div>
                <div className="form-group"><label>Type *</label>
                  <select className="form-control" value={form.type} onChange={e => setForm({ ...form, type: e.target.value })}>
                    <option value="">Select</option>
                    {ACCOUNT_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                  </select>
                </div>
              </div>
              <div className="form-group"><label>Ledger Name *</label><input className="form-control" value={form.account_name} onChange={e => setForm({ ...form, account_name: e.target.value })} /></div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div className="form-group"><label>Group (Tally)</label><input className="form-control" value={form.group_name} onChange={e => setForm({ ...form, group_name: e.target.value })} placeholder="e.g. Direct Income" /></div>
                <div className="form-group"><label>Sub-Group</label><input className="form-control" value={form.sub_group} onChange={e => setForm({ ...form, sub_group: e.target.value })} /></div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setModalOpen(false)}>Cancel</button>
              <button className="btn btn-primary" onClick={handleSave} disabled={!form.account_code || !form.account_name || !form.type}>Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/* =================================================================
   Journal Entries Tab
   ================================================================= */
function JournalEntries() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [form, setForm] = useState({ entry_date: new Date().toISOString().split('T')[0], narration: '' });
  const [lines, setLines] = useState([{ ...EMPTY_LINE }, { ...EMPTY_LINE }]);
  const [detailEntry, setDetailEntry] = useState(null);
  const [detailLines, setDetailLines] = useState([]);

  const fetchEntries = useCallback(async () => {
    try {
      const res = await apiFetch('/api/finance/journal-entries');
      if (res.ok) {
        const data = await res.json();
        setEntries(data.entries || []);
      }
    } catch (e) { /* handled */ }
    setLoading(false);
  }, []);

  useEffect(() => { fetchEntries(); }, [fetchEntries]);

  async function fetchAccounts() {
    try {
      const res = await apiFetch('/api/finance/chart-of-accounts');
      if (res.ok) {
        const data = await res.json();
        setAccounts((data.accounts || []).filter(a => a.is_active !== false));
      }
    } catch (e) { /* handled */ }
  }

  async function fetchDetail(entry) {
    try {
      const res = await apiFetch(`/api/finance/journal-entries/${entry.id}`);
      if (res.ok) {
        const data = await res.json();
        setDetailEntry(data.entry);
        setDetailLines(data.lines || []);
      }
    } catch (e) { /* handled */ }
  }

  function openCreate() {
    fetchAccounts();
    setForm({ entry_date: new Date().toISOString().split('T')[0], narration: '' });
    setLines([{ ...EMPTY_LINE }, { ...EMPTY_LINE }]);
    setModalOpen(true);
  }

  function updateLine(idx, field, value) {
    const updated = [...lines];
    updated[idx] = { ...updated[idx], [field]: value };
    setLines(updated);
  }

  function addLine() {
    setLines([...lines, { ...EMPTY_LINE }]);
  }

  function removeLine(idx) {
    if (lines.length <= 2) return;
    setLines(lines.filter((_, i) => i !== idx));
  }

  const totalDebit = lines.reduce((s, l) => s + (parseFloat(l.debit) || 0), 0);
  const totalCredit = lines.reduce((s, l) => s + (parseFloat(l.credit) || 0), 0);
  const isBalanced = Math.abs(totalDebit - totalCredit) < 0.01 && totalDebit > 0;

  async function handleSave() {
    if (!isBalanced) return;
    try {
      const payload = {
        entry_date: form.entry_date,
        narration: form.narration,
        lines: lines.filter(l => l.account_id).map(l => ({
          account_id: l.account_id,
          debit: parseFloat(l.debit) || 0,
          credit: parseFloat(l.credit) || 0,
          narration: l.narration
        }))
      };
      const res = await apiFetch('/api/finance/journal-entries', { method: 'POST', body: JSON.stringify(payload) });
      if (res.ok) {
        setModalOpen(false);
        fetchEntries();
      }
    } catch (e) { /* handled */ }
  }

  async function handleReverse(id) {
    if (!confirm('Reverse this journal entry?')) return;
    await apiFetch(`/api/finance/journal-entries/${id}/reverse`, { method: 'POST', body: JSON.stringify({}) });
    fetchEntries();
    setDetailEntry(null);
  }

  // Detail view
  if (detailEntry) {
    return (
      <div>
        <button className="btn btn-secondary" onClick={() => setDetailEntry(null)} style={{ marginBottom: 16 }}>Back to Journal Entries</button>
        <div className="card" style={{ marginBottom: 16 }}>
          <div className="card-header">
            <h4>{detailEntry.entry_number}</h4>
            <span className={`badge ${detailEntry.status === 'posted' ? 'badge-green' : detailEntry.status === 'reversed' ? 'badge-red' : 'badge-gray'}`}>{detailEntry.status}</span>
          </div>
          <div className="card-body" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
            <div><strong>Date:</strong> {detailEntry.entry_date}</div>
            <div><strong>Source:</strong> {detailEntry.source_module || '-'}</div>
            <div><strong>Narration:</strong> {detailEntry.narration || '-'}</div>
          </div>
        </div>
        <div className="card">
          <div className="card-header">
            <h4>Lines</h4>
            {detailEntry.status === 'posted' && <button className="btn btn-sm btn-danger" onClick={() => handleReverse(detailEntry.id)}>Reverse Entry</button>}
          </div>
          <table className="data-table">
            <thead><tr><th>Account Code</th><th>Account Name</th><th style={{ textAlign: 'right' }}>Debit</th><th style={{ textAlign: 'right' }}>Credit</th><th>Narration</th></tr></thead>
            <tbody>
              {detailLines.map((l, i) => (
                <tr key={i}>
                  <td style={{ fontFamily: 'monospace' }}>{l.account_code}</td>
                  <td>{l.account_name}</td>
                  <td style={{ textAlign: 'right' }}>{parseFloat(l.debit || 0) > 0 ? parseFloat(l.debit).toLocaleString(undefined, { minimumFractionDigits: 2 }) : '-'}</td>
                  <td style={{ textAlign: 'right' }}>{parseFloat(l.credit || 0) > 0 ? parseFloat(l.credit).toLocaleString(undefined, { minimumFractionDigits: 2 }) : '-'}</td>
                  <td>{l.narration || '-'}</td>
                </tr>
              ))}
              <tr style={{ fontWeight: 700, borderTop: '2px solid #e2e8f0' }}>
                <td colSpan={2}>Total</td>
                <td style={{ textAlign: 'right' }}>{detailLines.reduce((s, l) => s + parseFloat(l.debit || 0), 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                <td style={{ textAlign: 'right' }}>{detailLines.reduce((s, l) => s + parseFloat(l.credit || 0), 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
        <button className="btn btn-primary" onClick={openCreate}>+ New Journal Entry</button>
      </div>
      <div className="card">
        <table className="data-table">
          <thead><tr><th>Entry #</th><th>Date</th><th>Narration</th><th>Source</th><th>Status</th><th>Actions</th></tr></thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={6} style={{ textAlign: 'center' }}>Loading...</td></tr>
            ) : entries.length === 0 ? (
              <tr><td colSpan={6} style={{ textAlign: 'center', color: '#94a3b8' }}>No journal entries</td></tr>
            ) : entries.map(e => (
              <tr key={e.id}>
                <td><a href="#" onClick={ev => { ev.preventDefault(); fetchDetail(e); }} style={{ color: '#6366f1', fontWeight: 500 }}>{e.entry_number}</a></td>
                <td>{e.entry_date}</td>
                <td>{e.narration || '-'}</td>
                <td>{e.source_module || '-'}</td>
                <td><span className={`badge ${e.status === 'posted' ? 'badge-green' : e.status === 'reversed' ? 'badge-red' : 'badge-gray'}`}>{e.status}</span></td>
                <td><button className="btn btn-sm btn-secondary" onClick={() => fetchDetail(e)}>View</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modalOpen && (
        <div className="modal-overlay" onClick={() => setModalOpen(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: 800 }}>
            <div className="modal-header"><h3>New Journal Entry</h3><button className="modal-close" onClick={() => setModalOpen(false)}>X</button></div>
            <div className="modal-body">
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 12, marginBottom: 16 }}>
                <div className="form-group"><label>Date *</label><input type="date" className="form-control" value={form.entry_date} onChange={e => setForm({ ...form, entry_date: e.target.value })} /></div>
                <div className="form-group"><label>Narration</label><input className="form-control" value={form.narration} onChange={e => setForm({ ...form, narration: e.target.value })} /></div>
              </div>

              <table className="data-table" style={{ marginBottom: 8 }}>
                <thead><tr><th>Account</th><th style={{ width: 120 }}>Debit</th><th style={{ width: 120 }}>Credit</th><th style={{ width: 160 }}>Note</th><th style={{ width: 40 }}></th></tr></thead>
                <tbody>
                  {lines.map((line, idx) => (
                    <tr key={idx}>
                      <td>
                        <select className="form-control" value={line.account_id} onChange={e => updateLine(idx, 'account_id', e.target.value)} style={{ fontSize: 13 }}>
                          <option value="">Select account</option>
                          {accounts.map(a => <option key={a.id} value={a.id}>{a.account_code} - {a.account_name}</option>)}
                        </select>
                      </td>
                      <td><input type="number" className="form-control" value={line.debit} onChange={e => updateLine(idx, 'debit', e.target.value)} placeholder="0.00" step="0.01" /></td>
                      <td><input type="number" className="form-control" value={line.credit} onChange={e => updateLine(idx, 'credit', e.target.value)} placeholder="0.00" step="0.01" /></td>
                      <td><input className="form-control" value={line.narration} onChange={e => updateLine(idx, 'narration', e.target.value)} placeholder="Note" /></td>
                      <td><button className="btn btn-sm btn-danger" onClick={() => removeLine(idx)} disabled={lines.length <= 2}>X</button></td>
                    </tr>
                  ))}
                  <tr style={{ fontWeight: 700, borderTop: '2px solid #e2e8f0' }}>
                    <td style={{ textAlign: 'right' }}>Totals</td>
                    <td style={{ color: totalDebit > 0 ? '#10b981' : undefined }}>{totalDebit.toFixed(2)}</td>
                    <td style={{ color: totalCredit > 0 ? '#10b981' : undefined }}>{totalCredit.toFixed(2)}</td>
                    <td colSpan={2}>
                      {isBalanced ? (
                        <span style={{ color: '#10b981', fontWeight: 600 }}>Balanced</span>
                      ) : (
                        <span style={{ color: '#ef4444', fontWeight: 600 }}>
                          Diff: {Math.abs(totalDebit - totalCredit).toFixed(2)}
                        </span>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <button className="btn btn-sm btn-secondary" onClick={addLine}>+ Add Line</button>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setModalOpen(false)}>Cancel</button>
              <button className="btn btn-primary" onClick={handleSave} disabled={!isBalanced || !form.entry_date}>Post Entry</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/* =================================================================
   Trial Balance Tab
   ================================================================= */
function TrialBalance() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const fetchTB = useCallback(async () => {
    setLoading(true);
    try {
      let url = '/api/finance/trial-balance';
      const params = [];
      if (fromDate) params.push(`from_date=${fromDate}`);
      if (toDate) params.push(`to_date=${toDate}`);
      if (params.length) url += '?' + params.join('&');
      const res = await apiFetch(url);
      if (res.ok) setData(await res.json());
    } catch (e) { /* handled */ }
    setLoading(false);
  }, [fromDate, toDate]);

  useEffect(() => { fetchTB(); }, [fetchTB]);

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, alignItems: 'flex-end' }}>
        <div className="form-group" style={{ marginBottom: 0 }}><label>From</label><input type="date" className="form-control" value={fromDate} onChange={e => setFromDate(e.target.value)} /></div>
        <div className="form-group" style={{ marginBottom: 0 }}><label>To</label><input type="date" className="form-control" value={toDate} onChange={e => setToDate(e.target.value)} /></div>
        <button className="btn btn-primary" onClick={fetchTB}>Refresh</button>
      </div>

      <div className="card">
        <div className="card-header"><h4>Trial Balance</h4></div>
        <table className="data-table">
          <thead><tr><th>Code</th><th>Account</th><th>Type</th><th style={{ textAlign: 'right' }}>Debit</th><th style={{ textAlign: 'right' }}>Credit</th></tr></thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={5} style={{ textAlign: 'center' }}>Loading...</td></tr>
            ) : !data || !data.accounts || data.accounts.length === 0 ? (
              <tr><td colSpan={5} style={{ textAlign: 'center', color: '#94a3b8' }}>No data</td></tr>
            ) : (
              <>
                {data.accounts.map((a, i) => (
                  <tr key={i}>
                    <td style={{ fontFamily: 'monospace' }}>{a.account_code}</td>
                    <td>{a.account_name}</td>
                    <td>{a.type}</td>
                    <td style={{ textAlign: 'right' }}>{parseFloat(a.total_debit).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                    <td style={{ textAlign: 'right' }}>{parseFloat(a.total_credit).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                  </tr>
                ))}
                <tr style={{ fontWeight: 700, borderTop: '2px solid #e2e8f0', background: '#f8fafc' }}>
                  <td colSpan={3}>Total</td>
                  <td style={{ textAlign: 'right' }}>{(data.totals?.debit || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                  <td style={{ textAlign: 'right' }}>{(data.totals?.credit || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* =================================================================
   Profit & Loss Tab
   ================================================================= */
function ProfitLoss() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const fetchPL = useCallback(async () => {
    setLoading(true);
    try {
      let url = '/api/finance/profit-loss';
      const params = [];
      if (fromDate) params.push(`from_date=${fromDate}`);
      if (toDate) params.push(`to_date=${toDate}`);
      if (params.length) url += '?' + params.join('&');
      const res = await apiFetch(url);
      if (res.ok) setData(await res.json());
    } catch (e) { /* handled */ }
    setLoading(false);
  }, [fromDate, toDate]);

  useEffect(() => { fetchPL(); }, [fetchPL]);

  function renderSection(title, items, positiveSign) {
    const total = items.reduce((s, r) => s + Math.abs(parseFloat(r.net_amount)), 0);
    return (
      <div className="card" style={{ marginBottom: 12 }}>
        <div className="card-header"><h4>{title}</h4><span style={{ fontWeight: 700, fontSize: 18 }}>{total.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span></div>
        <table className="data-table">
          <thead><tr><th>Code</th><th>Account</th><th>Group</th><th style={{ textAlign: 'right' }}>Amount</th></tr></thead>
          <tbody>
            {items.length === 0 ? (
              <tr><td colSpan={4} style={{ textAlign: 'center', color: '#94a3b8' }}>No data</td></tr>
            ) : items.map((r, i) => (
              <tr key={i}>
                <td style={{ fontFamily: 'monospace' }}>{r.account_code}</td>
                <td>{r.account_name}</td>
                <td>{r.group_name || '-'}</td>
                <td style={{ textAlign: 'right' }}>{Math.abs(parseFloat(r.net_amount)).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, alignItems: 'flex-end' }}>
        <div className="form-group" style={{ marginBottom: 0 }}><label>From</label><input type="date" className="form-control" value={fromDate} onChange={e => setFromDate(e.target.value)} /></div>
        <div className="form-group" style={{ marginBottom: 0 }}><label>To</label><input type="date" className="form-control" value={toDate} onChange={e => setToDate(e.target.value)} /></div>
        <button className="btn btn-primary" onClick={fetchPL}>Refresh</button>
      </div>

      {loading ? <p style={{ textAlign: 'center' }}>Loading...</p> : !data ? <p style={{ textAlign: 'center', color: '#94a3b8' }}>No data</p> : (
        <>
          {renderSection('Revenue', data.revenue || [])}
          {renderSection('Expenses', data.expenses || [])}
          <div className="card" style={{ background: data.totals?.netIncome >= 0 ? '#f0fdf4' : '#fef2f2' }}>
            <div className="card-body" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 20 }}>
              <h3 style={{ margin: 0 }}>Net Income</h3>
              <span style={{ fontSize: 24, fontWeight: 700, color: data.totals?.netIncome >= 0 ? '#10b981' : '#ef4444' }}>
                {(data.totals?.netIncome || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
              </span>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

/* =================================================================
   Balance Sheet Tab
   ================================================================= */
function BalanceSheet() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [asOfDate, setAsOfDate] = useState('');

  const fetchBS = useCallback(async () => {
    setLoading(true);
    try {
      let url = '/api/finance/balance-sheet';
      if (asOfDate) url += `?as_of_date=${asOfDate}`;
      const res = await apiFetch(url);
      if (res.ok) setData(await res.json());
    } catch (e) { /* handled */ }
    setLoading(false);
  }, [asOfDate]);

  useEffect(() => { fetchBS(); }, [fetchBS]);

  function renderSection(title, items, total, color) {
    return (
      <div className="card" style={{ marginBottom: 12 }}>
        <div className="card-header"><h4>{title}</h4><span style={{ fontWeight: 700, fontSize: 18, color }}>{total.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span></div>
        <table className="data-table">
          <thead><tr><th>Code</th><th>Account</th><th>Group</th><th style={{ textAlign: 'right' }}>Balance</th></tr></thead>
          <tbody>
            {items.length === 0 ? (
              <tr><td colSpan={4} style={{ textAlign: 'center', color: '#94a3b8' }}>No data</td></tr>
            ) : items.map((r, i) => (
              <tr key={i}>
                <td style={{ fontFamily: 'monospace' }}>{r.account_code}</td>
                <td>{r.account_name}</td>
                <td>{r.group_name || '-'}</td>
                <td style={{ textAlign: 'right' }}>{parseFloat(r.balance).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, alignItems: 'flex-end' }}>
        <div className="form-group" style={{ marginBottom: 0 }}><label>As of Date</label><input type="date" className="form-control" value={asOfDate} onChange={e => setAsOfDate(e.target.value)} /></div>
        <button className="btn btn-primary" onClick={fetchBS}>Refresh</button>
      </div>

      {loading ? <p style={{ textAlign: 'center' }}>Loading...</p> : !data ? <p style={{ textAlign: 'center', color: '#94a3b8' }}>No data</p> : (
        <>
          {renderSection('Assets', data.assets || [], data.totals?.assets || 0, '#10b981')}
          {renderSection('Liabilities', data.liabilities || [], data.totals?.liabilities || 0, '#ef4444')}
          {renderSection('Equity', data.equity || [], data.totals?.equity || 0, '#6366f1')}
          <div className="card" style={{ background: '#f8fafc' }}>
            <div className="card-body" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, padding: 20 }}>
              <div style={{ textAlign: 'center' }}>
                <div style={{ color: '#64748b', fontSize: 14 }}>Total Assets</div>
                <div style={{ fontSize: 20, fontWeight: 700, color: '#10b981' }}>{(data.totals?.assets || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</div>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{ color: '#64748b', fontSize: 14 }}>Liabilities + Equity</div>
                <div style={{ fontSize: 20, fontWeight: 700, color: '#6366f1' }}>{((data.totals?.liabilities || 0) + (data.totals?.equity || 0)).toLocaleString(undefined, { minimumFractionDigits: 2 })}</div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
